import {styled, Drawer, Box, Tabs} from '@mui/material';

export const StyledBottomSheet = styled(Drawer)(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0px 0px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    height: 'fit-content',
    padding: theme.spacing(0, 1, 2, 1)
  },
  '& .MuiDialogActions-root': {
    display: 'flex',
    gap: theme.spacing(2)
  },
  '& .MuiDialogContent-root': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  '& .MuiDialogTitle-root': {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1, 0, 0, 0)
  }
}));

export const TabMainContainer = styled(Box)(({theme}) => ({
  backgroundColor: '#F4F4F5',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'center',
  margin: '4px 8px',
  alignItems: 'center'
}));

export const StyledTabs = styled(Tabs)(({theme}) => ({
  display: 'flex',
  width: '100%',
  margin: 0,
  alignItems: 'center',
  minHeight: theme.spacing(4),
  color: '#18181B',
  '& .MuiTabs-indicator': {display: 'none'},
  '& .MuiTab-root': {
    flex: 1,
    textTransform: 'none',
    borderRadius: '8px',
    fontWeight: 400,
    color: '#18181B',
    margin: 0,
    padding: theme.spacing(1),
    fontSize: 12,
    lineHeight: theme.spacing(2.25),
    alignSelf: 'center',
    minHeight: theme.spacing(3),
    display: 'flex',
    gap: theme.spacing(0.5)
  },
  '& .Mui-selected': {
    backgroundColor: theme.palette.common.mds_global_color_white,
    fontWeight: 700,
    minHeight: theme.spacing(3),
    padding: theme.spacing(2, 0, 2, 0),
    alignSelf: 'center',
    height: theme.spacing(3),
    color: '#18181B !important',
    display: 'flex',
    gap: theme.spacing(0.5)
  }
}));
